const getters = {
  sidebar: state => state.app.sidebar,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  companyType:state=>state.user.companyType,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js